/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2025 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

let navConfig = {};

export async function getNavConfigAndUserData() {
    await fetch('../../ui/navContext/properties')
    .then((contextResp) => contextResp.json()) 
    .then(contextProps => {
        navConfig.isShowPreferencesLink = contextProps.isShowPreferencesLink;
        navConfig.isShowHelpAndSupportLinks = contextProps.isShowHelpAndSupportLinks;
        navConfig.isShowAboutLink = contextProps.isShowAboutLink;
        navConfig.projectPickerQueryId = contextProps.projectPickerQueryId;
        navConfig.isCompanyLevelAccessAllowed = contextProps.isCompanyLevelAccessAllowed;
        navConfig.isRTL = contextProps.isLanguageMirrored;
        navConfig.userLanguageId = contextProps.userLanguageId;
        navConfig.isForceLogOutOnNoCompanyLevelAccess = contextProps.isForceLogOutOnNoCompanyLevelAccess;
        navConfig.projectId = contextProps.projectId;
        navConfig.projectName = contextProps.projectName;
        navConfig.priorProjectId = contextProps.priorProjectId;
        navConfig.priorProjectName = contextProps.priorProjectName;
        navConfig.headerTitle = contextProps.headerTitle;
        navConfig.loginObj = contextProps.loginObj;
        navConfig.userProfile = contextProps.userProfile;
        navConfig.isOAuthUser = contextProps.isOAuthUser;
        navConfig.isAccessibilityEnabled = contextProps.isAccessibilityEnabled;
        navConfig.watsonOrchestrateEnabled = contextProps.watsonOrchestrateEnabled;
        navConfig.watsonOrchestrateIntegrationId = contextProps.watsonOrchestrateIntegrationId;
        navConfig.watsonOrchestrateRegionId = contextProps.watsonOrchestrateRegionId;
        navConfig.watsonOrchestrateInstanceId = contextProps.watsonOrchestrateInstanceId;

    });
  }
  
  export function getNavConfigData() {
    return navConfig;
  }

  const getContextUrl = ()=> {
    let triContextUrl = "../..";
    if (process.env.NODE_ENV === 'development') {
      triContextUrl = process.env.REACT_APP_DEV_HOST;
    }
    return triContextUrl;
  }
  
  export const CONTEXT_URL = getContextUrl();
